'use strict'

Vue.component('awe-opening-hours', {
  props: {
    hours: {type: Array, default: ()=> { return [] }},
    timezone: {type: String, default: ''},
    open24: {type: Boolean, default: false},
  },
  data: function(){
    return {
      expanded: false,
      isOpen: false,
      nextLimit: '',
      nextDay: '',
      i18n: this.$root.i18n,
      days:['su', 'mo', 'tu', 'we', 'th', 'fr', 'sa'],
      boundaries: {}
    }
  },
  computed: {
    _hours: function(){
      if (this.open24)
        return [['Mo-Su', '0:00-24:00']]
      else
        return this.hours
    }
  },

  mounted:function(){
    let today = new Date() // user local time

    if (this.open24){
      this.isOpen = true
      this.nextLimit = ''
      return
    }

    // convert curent time in the given timezone
    if (this.timezone){
      const storeTZDate = today.toLocaleString('en-US', {timeZone: this.timezone})
      today = new Date(storeTZDate)
    }

    this.boundaries = this.getBoundaries() // parse ranges


    const dow = today.getDay() // 0-6 integer, starting on sunday
    const dayHours = this.boundaries[this.days[dow]]
    
    if (dayHours){
      const currentTime = today.getHours() + today.getMinutes() / 60
      // check store open status for the current time, and next opening or closing time
      let [isOpen, nextBoundary] = this.findOpenState(dayHours, currentTime)
      this.isOpen = isOpen

      // next open/close time not found OR is end of day, look the following day
      if  (nextBoundary == null || nextBoundary.startsWith('24')){
        let nextDow = null
        let nextHours = null
        let i = 0

        while (!nextHours && i++ < 7) {
          nextDow = this.days[(dow + i) % 7]
          nextHours = this.boundaries[nextDow]
        }

        if (nextHours && nextBoundary == null) {
          // get next opening time
          nextBoundary = nextHours[0][0]
        }
        else if (nextHours && nextHours[0][1] === 0) {
          nextBoundary = nextHours[1][0]
        }
      }

      this.nextLimit = nextBoundary
    }
  },
  methods: {
    // returns an object with day code as key and value as list of [string hour, numerical hour]
    getBoundaries: function(){
      let bounds = {}
      let overlap = []

      for (let i = 0; i < this.hours.length; i++){
        const dayBounds = overlap
        for (let j = 1; j < this.hours[i].length; j++){
          const rx = /(\d{1,2})[\.hH:](\d{0,2})/g
          let m
          let prev = -1
          while (m = rx.exec(this.hours[i][j])){
            let str = m[0]
            const h = parseInt(m[1], 10)
            const min = parseInt(m[2], 10)
            let hour = h + min/60

            // detects when range overlaps midnight
            if (hour < prev){
              // create an additional range for the next day to starts with
              overlap = [ ['00:00', 0], [str, hour] ]
              str = '24:00'
              hour = 24
            }
            else
              overlap = []

            dayBounds.push([str, hour]) // push string and numerical value
            prev = hour
          }
          bounds[this.hours[i][0].toLowerCase()] = dayBounds
        }
      }

      // overlap between sunday and monday
      if (overlap.length)
        bounds.mo = overlap.concat(bounds.mo)

      return bounds
    },
    // Finds whether store is open, and next opening/closing time
    findOpenState: function(hours, currentTime){
      let open = false
      let nextLimit

      // Hours should be in pairs, for each range opening and closing times.
      if (hours.length % 2 === 0){
        let i = 0
        let quit = false
        
        while (i < hours.length && !quit){
          let startTime =  hours[i++], closeTime = hours[i++]

          if (currentTime < startTime[1]){
          	quit = true
            nextLimit = startTime[0]
          }
          else if (currentTime >= startTime[1]  && currentTime < closeTime[1]){
            open = true
            quit = true
            nextLimit =  closeTime[0]
          }
        }
      }
      return [open, nextLimit]

    },
    toggle: function(event){
      event?.stopPropagation()
      this.expanded = !this.expanded
      this.$emit('toggle', this.expanded)
    },
  },
  template: `
  <div class="opening-hours" :class="{expanded: expanded}">
    <div class="hr-title" @click="toggle">
      <span class="icon-time"></span>
      <span class="title-content">
      {{ i18n.getString(isOpen ? 'STORE_OPEN': 'STORE_CLOSED')}}
      {{ nextLimit ? ' - '+ i18n.getString(isOpen ? 'STORE_CLOSES_AT' : (nextDay ? 'STORE_OPENS_AT_'+ nextDay : 'STORE_OPENS_AT'), {hour: i18n.getOpeningHours(nextLimit)}) : ''}}
      </span>
      <svg role="img" aria-hidden="true" viewBox="0 0 25 15" xmlns="http://www.w3.org/2000/svg" class="arrow"><path d="M21 1a2.1213 2.6517 45 013 3L14 14a2 2.1 0 01-3 0L1 4a2.6517 2.1213 45 013.0988-2.9012l8.5 8.5z"></path></svg>
    </div>
    <!--<transition name="rolldown">-->
      <div class="hours-ctnr" v-show="expanded">
        <template v-for="item in _hours">
          <span>{{ i18n.getOpeningDays(item[0]) }}</span>
          <span>{{ i18n.getOpeningHours(item.slice(1).join(', ')) }}</span>
        </template>
      </div>
    <!--/transition>-->
  </div>
  `
})
